import * as React from 'react';
import { useFilterContext } from '../../FilterContext';

export function Search() {
  const { handleSearch, searchValue } = useFilterContext();

  return (
    <input
      type="search"
      placeholder="Search..."
      className="filter__dropdown-search filter__dropdown-item"
      value={searchValue}
      onChange={handleSearch}
    />
  );
}
